<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let { items = [] as string[] } = $props();
</script>

<div class="fade-up" use:observe>
  <div class="logo-cloud">
    {#each items as item}
      <span>{item}</span>
    {/each}
  </div>
</div>
